// DS: i12.3
import React from 'react';
import IconWrap, { Props } from '../../IconWrap';

const Clipboard: React.FC<Props> = props => (
  <IconWrap {...props}>
    <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
      <path d="M5.25344 7.54678C5.25344 7.93617 5.57216 8.25183 5.96531 8.25183L10.0331 8.25183C10.4263 8.25183 10.745 7.93617 10.745 7.54678C10.745 7.1574 10.4263 6.84174 10.0331 6.84174L5.96531 6.84174C5.57216 6.84174 5.25344 7.1574 5.25344 7.54678Z" />
      <path d="M5.96531 9.66181C5.57216 9.66181 5.25344 9.97747 5.25344 10.3669C5.25344 10.7562 5.57216 11.0719 5.96531 11.0719H10.0331C10.4263 11.0719 10.745 10.7562 10.745 10.3669C10.745 9.97747 10.4263 9.66181 10.0331 9.66181H5.96531Z" />
      <path d="M5.96451 1C5.40287 1 4.94756 1.45094 4.94756 2.0072V3.11498H2.91525C2.40977 3.11498 2 3.52083 2 4.02147V14.0935C2 14.5942 2.40977 15 2.91525 15H13.0847C13.5902 15 14 14.5942 14 14.0935V4.02147C14 3.52083 13.5902 3.11498 13.0847 3.11498H11.0493V2.0072C11.0493 1.45094 10.594 1 10.0323 1H5.96451ZM3.83051 13.187V4.92795H12.1695V13.187H3.83051Z" />
    </svg>
  </IconWrap>
);
Clipboard.displayName = 'Clipboard';

export default Clipboard;
